export enum QuoteType {
  /** Indicative */
  Indicative = 0,
  /** Tradeable */
  Tradeable = 1,
  /** Restricted tradeable */
  RestrictedTradeable = 2,
  /** Counter (tradeable) */
  Counter = 3,
  /** Initially tradeable */
  InitiallyTradeable = 4,
}
